var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.785 7.289 C 7.424 7.385,7.191 7.804,7.285 8.190 C 7.328 8.368,7.443 8.493,9.134 10.190 L 10.938 12.000 9.134 13.810 C 7.443 15.507,7.328 15.632,7.285 15.810 C 7.150 16.367,7.633 16.850,8.190 16.715 C 8.368 16.672,8.493 16.557,10.190 14.866 L 12.000 13.062 13.810 14.866 C 15.507 16.557,15.632 16.672,15.810 16.715 C 16.367 16.850,16.850 16.367,16.715 15.810 C 16.672 15.632,16.557 15.507,14.866 13.810 L 13.062 12.000 14.866 10.190 C 16.557 8.493,16.672 8.368,16.715 8.190 C 16.850 7.633,16.367 7.150,15.810 7.285 C 15.632 7.328,15.507 7.443,13.810 9.134 L 12.000 10.938 10.190 9.134 C 8.501 7.451,8.367 7.328,8.192 7.285 C 7.980 7.234,7.994 7.234,7.785 7.289 ",
    stroke: "none",
    fillRule: "evenodd",
    fill: "black"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDisabled);
export default __webpack_public_path__ + "static/media/delete-disabled.14dddd49.svg";
export { ForwardRef as ReactComponent };